// src/components/Header.js
import React, { useContext, useState } from "react";
import styled from "styled-components";
import { FiMenu, FiX } from "react-icons/fi";
import logoImg from "./images/logo.png";
import ContactModal from "./components/ContactModal";
import LoginModal from "./components/LoginSignupModal";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "./context/UserContext";

const HeaderWrapper = styled.header`
  background: linear-gradient(-45deg, #0a0a0a, #1a1a1a, #0f0f0f, #1c1c1c);
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 999;
`;

const Logo = styled.div`
  cursor: pointer;
  img {
    height: 50px;
    width: auto;
    object-fit: contain;
  }
`;

const NavCenter = styled.nav`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex: 1; /* ✅ pushes it to center */
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.div`
  cursor: pointer;
  color: ${({ active }) => (active ? "#fff" : "#ccc")};
  font-weight: ${({ active }) => (active ? "600" : "500")};
  transition: 0.3s;
  &:hover {
    color: #fff;
  }
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MenuIcon = styled.div`
  font-size: 1.8rem;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? "0" : "-100%")};
  width: 80%;
  height: 100vh;
  background: #111;
  color: #fff;
  padding: 2rem;
  transition: 0.3s ease-in-out;
  z-index: 1000;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const CloseIcon = styled.div`
  align-self: flex-end;
  font-size: 1.8rem;
  cursor: pointer;
`;

const MobileNavLink = styled.div`
  color: #ccc;
  font-size: 1.2rem;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`;

const SpecialButton = styled.button`
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #ff7a18, #ff0066);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, #ff5722, #e91e63);
  }
`;

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const location = useLocation();

  const handleNavClick = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  // ✅ Menu items (center nav only)
  const centerMenuItems = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Courses", path: "/courses" },
    { label: "About Us", path: "/about-us" },
    { label: "Contact Us", path: "/contact-us" },

    //  { label: "Blogs", path: "/blogs" },
  ];

  return (
    <>
      <HeaderWrapper>
        {/* ✅ Left Logo */}
        <Logo onClick={() => navigate("/")}>
          <img src={logoImg} alt="Engineer Codewala" />
        </Logo>

        {/* ✅ Center Nav */}
        <NavCenter>
          {centerMenuItems.map((item, i) => (
            <NavLink
              key={i}
              active={location.pathname === item.path}
              onClick={() => handleNavClick(item.path)}
            >
              {item.label}
            </NavLink>
          ))}
        </NavCenter>

        {/* ✅ Right Actions */}
        <RightActions>
          {user && (
            <NavLink onClick={() => navigate("/myprofile")}>My Profile</NavLink>
          )}
          {!user && (
            <SpecialButton onClick={() => setIsLoginModalOpen(true)}>
              Login / Register
            </SpecialButton>
          )}

          <SpecialButton onClick={() => setIsContactOpen(true)}>
            Get Quotation
          </SpecialButton>
        </RightActions>

        {/* ✅ Hamburger for mobile */}
        <MenuIcon onClick={() => setMenuOpen(true)}>
          <FiMenu />
        </MenuIcon>
      </HeaderWrapper>

      {/* ✅ Mobile Sidebar */}
      <MobileMenu open={menuOpen}>
        <CloseIcon onClick={() => setMenuOpen(false)}>
          <FiX />
        </CloseIcon>

        {centerMenuItems.map((item, i) => (
          <MobileNavLink key={i} onClick={() => handleNavClick(item.path)}>
            {item.label}
          </MobileNavLink>
        ))}

        {user && (
          <MobileNavLink onClick={() => handleNavClick("/myprofile")}>
            My Profile
          </MobileNavLink>
        )}

        {!user && (
          <MobileNavLink onClick={() => setIsLoginModalOpen(true)}>
            Login / Register
          </MobileNavLink>
        )}

        {/* {user && (
          <SpecialButton onClick={() => setIsContactOpen(true)}>
            Get Quotation
          </SpecialButton>
        )} */}
        <SpecialButton onClick={() => setIsContactOpen(true)}>
          Get Quotation
        </SpecialButton>
        {/* Modals */}
        <ContactModal
          isOpen={isContactOpen}
          onClose={() => setIsContactOpen(false)}
        />
        <LoginModal
          onClose={() => setIsLoginModalOpen(false)}
          isOpen={isLoginModalOpen}
          onGoogleLogin={() => {}}
        />
      </MobileMenu>
    </>
  );
}
